import React from 'react';
import { connect } from 'react-redux';

import * as ProjectActions from "../../data/projects/ProjectActions";

import ProjectSettingsDialog from './ProjectSettingsDialog';

const mapStateToProps = (state, ownProps) => ({
    accountId: state.currentAccountId
});

const mapDispatchToProps = {
    onSave: ProjectActions.updateProject,
    onRemove: ProjectActions.removeProject
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProjectSettingsDialog);
